// MarcaDetalle.jsx
import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../Firebase/Firebase";
import Navbar from '../Components/NavBarV2';
import Footer from '../Components/footer';
import FloatingWhatsApp from '../Components/whatsappbutton.js';
import LoadingScreen from '../Components/loading.js';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube, FaWhatsapp } from "react-icons/fa";
import "./MarcaDetalle.css";

const MarcaDetalle = () => {
  const { id } = useParams();
  const [marca, setMarca] = useState(null);
  const [lugares, setLugares] = useState([]);
  const [verMapa, setVerMapa] = useState(false);

  useEffect(() => {
    const fetchMarca = async () => {
      const ref = doc(db, "marca", id);
      const snapshot = await getDoc(ref);
      if (snapshot.exists()) {
        setMarca({ id: snapshot.id, ...snapshot.data() });
      }
    };

    const fetchLugares = async () => {
      const lugaresRef = collection(db, "marca", id, "lugar");
      const snapshot = await getDocs(lugaresRef);
      const lugaresData = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setLugares(lugaresData);
    };

    fetchMarca();
    fetchLugares();
  }, [id]);

  return (
    <div className="cont-gen-marca">
      <Navbar />
      <FloatingWhatsApp />
      <div className="marca-header-banner">
        <img src={marca?.banner || marca?.logo} alt="Banner marca" />
      </div>

      <section className="marca-producto">
        <div className="producto-imagen">
        </div>
        <div className="producto-info">
          <h2>{marca?.nombre}</h2>
          <p>{marca?.descripcion}</p>


        </div>
      </section>
      <section className="lugares-container">
        <h3>Ubicaciones</h3>
        {lugares.map((lugar) => {

          return (
            <Link to={`/lugar/${lugar.id}`} key={lugar.id} className="lugar-card-link">
              <div className="ubicacion-laofi">
                <div className="ubicacion-img">
                  <img src={lugar.ImagenUrl} alt={lugar.NombreLugar} />
                </div>

                <div className="ubicacion-info">
                  <h4>{lugar.NombreLugar}</h4>
                  <p><strong>{lugar.Sector}</strong></p>
                  <p>{lugar.CiudadLugar}</p>
                  <p>{lugar.Direccion}</p>

                  <button
                    className="ver-ubicacion-btn"
                    onClick={(e) => {
                      e.preventDefault(); // evita que el link se dispare
                      e.stopPropagation(); // evita que el link envuelva el click
                      setVerMapa(!verMapa);
                    }}
                  >
                    Ver ubicación <span>{verMapa ? "▲" : "▼"}</span>
                  </button>

                  {verMapa && (
                    <div className="mapa-ubicacion active" onClick={(e) => e.stopPropagation()}>
                      <iframe
                        title={`Mapa ${lugar.NombreLugar}`}
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        style={{ border: 0 }}
                        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyB7Sx1jXG9YS5c7Iy-qxOEfkECMh7syeqg&q=${lugar.Latitud},${lugar.Longitud}`}
                        allowFullScreen
                      ></iframe>
                    </div>
                  )}
                </div>
              </div>
            </Link>
          );
        })}

      </section>
      <section className="marca-producto">
        <div className="producto-imagen">
        </div>
        <div className="producto-info">
          <div className="producto-imagen">
        <img src={marca?.banner || marca?.logo} alt="Banner marca" />
          </div>
          <ul className="redes-sociales">
            {marca?.redes?.map((red, index) => {
              const [nombre, url] = red.split(/:\s(.+)/);
              const iconMap = {
                Facebook: <FaFacebook />, Instagram: <FaInstagram />, LinkedIn: <FaLinkedin />, TwitterX: <FaTwitter />, Twitter: <FaTwitter />, YouTube: <FaYoutube />, WhatsApp: <FaWhatsapp />
              };
              return (
                <li key={index}>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    {iconMap[nombre.trim()] || "🔗"} {nombre}
                  </a>
                </li>
              );
            })}
          </ul>
          <p><strong>Correo:</strong> {marca?.correo}</p>
          <p><strong>Teléfono:</strong> {marca?.telefono}</p>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MarcaDetalle;
